import React, { useMemo } from 'react';

import Select from 'components/Select';

import PresetPicker from './PresetPicker';
import { useLoadPresets } from './data';

interface PresetsConfig {
  screenKey: string;
  activePresetId?: number;
  state: any;
  onApply: (activePreset: any) => void;
  changed?: boolean;
}

const Presets: React.FC<PresetsConfig> = ({
  screenKey,
  activePresetId,
  onApply,
  state,
}) => {
  const { data, error, isLoading } = useLoadPresets(screenKey);

  const activePresetData = useMemo(() => {
    if (data) {
      return (data as any[]).find(({ id }) => id === activePresetId)?.data;
    }
    return null;
  }, [activePresetId, data]);

  const changes = useMemo(() => {
    if (activePresetData) {
      return JSON.stringify(activePresetData) !== JSON.stringify(state);
    }
    return false;
  }, [activePresetData, state]);

  const handleChange = (_: any, preset: any) => {
    onApply(preset);
  };

  return (
    <Select
      data={data}
      value={activePresetId}
      label={'Presets'}
      onChange={handleChange}
      ModalComponent={PresetPicker}
      error={error}
      isLoading={isLoading}
      getLabel={({ title }: any) => title}
      getBadge={({ id }: any) => {
        return changes && id === activePresetId
          ? { color: 'danger-tint', label: 'changes' }
          : null;
      }}
      modalParams={{
        screenKey: screenKey,
        activePresetId: activePresetId,
        state: state,
        onApply: onApply,
      }}
    />
  );
};

export default Presets;
